import { useQuery } from '@tanstack/react-query';
import { areasApi } from '../lib/api.js';

export function useAreas() {
  return useQuery({
    queryKey: ['areas'],
    queryFn: () => areasApi.list(),
    staleTime: 5 * 60 * 1000,
    select: (data) => data.items,
    gcTime: 30 * 60 * 1000,
  });
}
